import type { AcionamentoCobom, CenaTabletop, ItemAcionamentoCobom } from '../tipos'
import type { TipoMarcoOcorrencia } from './tipos'

/**
 * Modelo editável do acionamento. Só a natureza vem sugerida; local, horário
 * e recursos ficam vazios até o instrutor preencher — a mensagem nunca
 * completa lacunas com fatos inventados. As duas informações iniciais são
 * relatos NÃO confirmados, como a central normalmente recebe.
 */
export function criarAcionamentoModelo(): AcionamentoCobom {
  return {
    natureza: 'colisão entre veículos',
    local: '',
    horario: '',
    recursos: '',
    informacoes: [
      { id: 'info-vitimas', texto: 'possíveis vítimas', confirmado: false, visivel: true },
      { id: 'info-riscos', texto: 'riscos ainda não confirmados', confirmado: false, visivel: true },
    ],
  }
}

export function acionamentoDaCena(cena: CenaTabletop): AcionamentoCobom {
  return cena.acionamento ?? criarAcionamentoModelo()
}

export function definirAcionamento(cena: CenaTabletop, acionamento: AcionamentoCobom): CenaTabletop {
  return { ...cena, acionamento }
}

function listar(itens: readonly ItemAcionamentoCobom[]): string {
  return itens.map((i) => i.texto.trim()).filter(Boolean).join('; ')
}

/**
 * Texto curto para ler em voz alta ou mostrar no projetor. Separa o que a
 * central confirmou do que é só relato do solicitante; itens ocultos pelo
 * instrutor não entram.
 */
export function mensagemAcionamento(acionamento: AcionamentoCobom): string {
  const natureza = acionamento.natureza.trim() || 'natureza a confirmar'
  const local = acionamento.local.trim() || 'local a confirmar'
  const horario = acionamento.horario.trim()
  const visiveis = acionamento.informacoes.filter((i) => i.visivel && i.texto.trim())
  const confirmadas = listar(visiveis.filter((i) => i.confirmado))
  const relatos = listar(visiveis.filter((i) => !i.confirmado))
  const recursos = acionamento.recursos.trim()

  const partes = [`Guarnição, ocorrência de ${natureza} em ${local}${horario ? `, chamado às ${horario}` : ''}.`]
  if (confirmadas) partes.push(`Confirmado pela central: ${confirmadas}.`)
  if (relatos) partes.push(`Solicitante informa, sem confirmação: ${relatos}.`)
  if (recursos) partes.push(`Recursos empenhados: ${recursos}.`)
  partes.push('Desloquem e atualizem o COBOM após a avaliação inicial.')
  return partes.join(' ')
}

export const ROTULOS_MARCO: Readonly<Record<TipoMarcoOcorrencia, string>> = {
  despacho: 'Acionamento lido',
  deslocamento: 'Deslocamento confirmado',
  chegada: 'Chegada à cena',
  atualizacao_cobom: 'COBOM atualizado',
}

/** Marcos que só acontecem uma vez; a atualização da central pode se repetir. */
export const MARCOS_UNICOS: readonly TipoMarcoOcorrencia[] = ['despacho', 'deslocamento', 'chegada']
